import React, { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import Icon from '../../common/Icons';
import { HEAD_DOCTOR_COPY } from '../headDoctorCopy';
import { REPORTS_NAV_ITEMS } from './reportsNavConfig';

const DEFAULT_COPY = HEAD_DOCTOR_COPY.REPORTS;
const DEFAULT_NAV_ICONS = HEAD_DOCTOR_COPY.NAV;

function flattenNavItems(navItems, navGroups) {
  if (Array.isArray(navItems) && navItems.length) return navItems;
  if (Array.isArray(navGroups) && navGroups.length) {
    return navGroups.flatMap((group) => group.items || []);
  }
  return REPORTS_NAV_ITEMS;
}

export default function ReportsSubNav({
  copy = DEFAULT_COPY,
  navItems,
  navGroups,
  navIcons = DEFAULT_NAV_ICONS
}) {
  const items = useMemo(
    () => flattenNavItems(navItems, navGroups),
    [navItems, navGroups]
  );

  return (
    <nav className="hd-reports-subnav" aria-label={copy.SUB_NAV_ARIA}>
      <div className="hd-reports-subnav__items">
        {items.map((item) => {
          const navMeta = navIcons[item.navKey] || {};
          return (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `hd-reports-subnav__link${isActive ? ' is-active' : ''}`
              }
            >
              <span className="hd-reports-subnav__icon" aria-hidden>
                <Icon name={navMeta.icon || 'chartBar'} size={14} />
              </span>
              <span className="hd-reports-subnav__text">{copy[item.labelKey]}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
